import React from 'react';
import { DatesProvider } from '@mantine/dates';
import { useI18n } from '../../../hooks/useI18n';
import { getDateLocale } from '../../../config/dateLocales';

interface LocalizedDatesProviderProps {
  children: React.ReactNode;
}

/**
 * Localized wrapper for Mantine's DatesProvider that automatically
 * syncs locale settings with the current application language
 */
export const LocalizedDatesProvider: React.FC<LocalizedDatesProviderProps> = ({ children }) => {
  const { currentLanguage } = useI18n();
  const dateLocale = getDateLocale(currentLanguage);

  return (
    <DatesProvider
      settings={{
        locale: dateLocale.locale,
        firstDayOfWeek: dateLocale.firstDayOfWeek,
        // Additional Mantine-specific settings
        consistentWeeks: false
      }}
    >
      {children}
    </DatesProvider>
  );
};